import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const AgeRestrictionDropdown = (props: DropdownWithoutOptionsProps<server.dto.AgeRestriction, server.dto.AgeRestrictions>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    options={serverReference.ageRestrictions}
    getLabel={ageRestriction => ageRestriction.text}
    getValue={ageRestriction => ageRestriction.value}
    excludeKeys={props.excludeKeys}
    config={{
      isSearchable: false,
      ...props.config
    }}
  />;
};

export default AgeRestrictionDropdown;